export const environment = {
  production: true,
  apiUrl: 'https://api.pia.publicare-gmbh.de',
  templateBuilderUrl: 'https://tb.pia.publicare-gmbh.de',
  auth: {
    clientId: 'cba0ff44-11ff-416f-a77c-e5504d032e47',
  },
};
